export type Community = {
  id: string | undefined;
  link: string | undefined;
  linkType: string | undefined;
  name: string | undefined;

  description?: string;
  region?: string;
  tags?: string[];
};

export const getExtendedTags = (community: Community) => {
  const extendedTags: string[] = [];
  if (!!community.region) {
    extendedTags.push(community.region);
  }

  if (!!community.tags) {
    extendedTags.push(...community.tags);
  }

  return extendedTags;
};

export const getLinkIconPath = (type: string | undefined) => {
  switch (type) {
    case "Discord":
      return "/images/icons/discord-dark.png";
    default:
      return "/images/icons/discord-dark.png";
  }
};

export const getHoverText = (linkType: string | undefined) => {
  switch (linkType) {
    case "Discord":
      return "Join Discord Server";
    case "Website":
    default:
      return "Go To Website";
  }
};
